import { useLoadGoogleTagManager } from "@lending/hooks/useLoadGoogleTagManager";
import { Institution } from "@lending/types";
import type { DataRouter } from "react-router";

interface LendingGoogleTagManagerProps {
  institution: Institution;
  router: DataRouter;
}

function LendingGoogleTagManager({ institution, router }: LendingGoogleTagManagerProps) {
  useLoadGoogleTagManager(institution, router);

  return null;
}

export default LendingGoogleTagManager;
